module.exports = __webpack_public_path__ + "img/tp-arrow-left.ae298ae3.svg";